module.exports = __webpack_public_path__ + "images/emoji/chestnut.79c32e6fcd2ce957fc42.png";